window.initializeUpsell = () => {
	const isCollection = document.querySelector('#upsellSliderCollection');
	const collectionData = JSON.parse(isCollection.textContent);

	if (!isCollection) {
		fetch('/cart.js', { credentials: 'same-origin' })
			.then(response => response.json())
			.then(data => {
				// const cartItems = data.items
				const cartItems = data.items.filter(item => {
					if (item.properties && typeof item.properties === 'object') {
					return !item.properties.hasOwnProperty('__discount');
					}
					return true;
				});
				if (cartItems.length > 0) {
					const cartItemIds = []
					cartItems.forEach(item => {
						cartItemIds.push(item.product_id)
					})
					fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${cartItemIds[0]}&limit=10&intent=related`)
						.then(response => response.json())
						.then(data => {
							const recommendedProducts = data.products
							const swipersWrappers = document.querySelectorAll('.swiper-wrapper.upsell-slider')
							const upsell__swipers = document.querySelectorAll('.upsell__swiper');
							const loading = document.querySelector('#loading-upsell')
							swipersWrappers.forEach((swiperWrapper, idx) => {
								recommendedProducts.forEach(product => {
									const slide = document.createElement('div')
									slide.classList.add('swiper-slide')
									const imageWrapper = createImg(product)
									slide.appendChild(imageWrapper)
									const infoWrapper = createInfoWrapper(product)
									slide.appendChild(infoWrapper)
									swiperWrapper.appendChild(slide)
								})
								const slider = swiper(upsell__swipers[idx])
								slider.update()
							})
						})
				}
			})
	} else {
		const recommendedProducts = collectionData
		const swipersWrappers = document.querySelectorAll('.swiper-wrapper.upsell-slider')
		const upsell__swipers = document.querySelectorAll('.upsell__swiper');
		const loading = document.querySelector('#loading-upsell')

		swipersWrappers.forEach((swiperWrapper, idx) => {
			recommendedProducts.forEach(product => {
				const slide = document.createElement('div')
				slide.classList.add('swiper-slide')
				const imageWrapper = createImg(product)
				slide.appendChild(imageWrapper)
				const infoWrapper = createInfoWrapper(product)
				slide.appendChild(infoWrapper)
				swiperWrapper.appendChild(slide)
			})
			const slider = swiper(upsell__swipers[idx])
			slider.update()
		})
	}
}

async function renderShopifySection(sections) {
  try {
    const response = await fetch(`?sections=${sections}`);
    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }
    const html = await response.json();
    return html;
  } catch (error) {
    console.error(`Error: ${error.message}`);
  }
}

const createImg = (product) => {
	const imageWrapper = document.createElement('a')
	const productHandler = product.handle;
	imageWrapper.classList.add('upsell__link')
	imageWrapper.href = `/products/${productHandler}`;
	const image = document.createElement('img')
	image.setAttribute('loading', 'lazy')
	image.src = product.featured_image
	image.alt = 'Upsell Product'
	image.height = 121
	image.width = 120
	imageWrapper.appendChild(image)

	return imageWrapper
}

const createInfoWrapper = (product) => {
  const infoWrapper = document.createElement('div');
  infoWrapper.classList.add('cart-item__details');

  const titleWrapper = document.createElement('div');
  titleWrapper.classList.add('upsell__title-wrap');

	const title = document.createElement('a');
  title.classList.add('cart-item__name', 'h4', 'break');
  title.href = product.url;
  title.textContent = product.title;
  titleWrapper.appendChild(title);
  
	const variantPrice = product.price;
  const variantComparePrice = product.compare_at_price;

  const priceWrapper = document.createElement('div');
  priceWrapper.classList.add('cart-item__price-wrapper');
  const price = document.createElement('span');
  price.classList.add('price', 'price--end');
  price.textContent = (Number(variantPrice) / 100).toFixed(2) + '€';
  priceWrapper.appendChild(price);

  if (variantPrice < variantComparePrice) {
    const comparePrice = document.createElement('span');
    const tachado = document.createElement('s');
    tachado.classList.add('price-item', 'price-item--regular');
    tachado.textContent = (Number(variantComparePrice) / 100).toFixed(2) + '€';
    comparePrice.appendChild(tachado);
    priceWrapper.appendChild(comparePrice);
  }
  titleWrapper.appendChild(priceWrapper);
	
	if (variantPrice < variantComparePrice) {
		const savePrice = document.createElement('span');
		savePrice.classList.add('ahorra');
		savePrice.textContent = '¡Ahorras ' + ((Number(variantComparePrice) - Number(variantPrice)) / 100).toFixed(2) + '€!';
		titleWrapper.appendChild(savePrice);
	}

	infoWrapper.appendChild(titleWrapper);

  const bottomWrapper = document.createElement('div');
  bottomWrapper.classList.add('upsell__bottom');

  const firstVariant = product.variants.find((v) => v.available);
  // const variantOptionsWrapper = document.createElement('div');
  // variantOptionsWrapper.classList.add('cart-item__variant-options');
  // firstVariant.options.forEach((option) => {
  //   const variantOption = document.createElement('span');
  //   variantOption.classList.add('cart-item__variant-option');
  //   variantOption.textContent = option;
  //   variantOptionsWrapper.appendChild(variantOption);
  // });
  // infoWrapper.appendChild(variantOptionsWrapper);

  if(window.productGiftDataObj){
	
	const createInputGift = document.createElement('input');
	const setAttrElement = (e, attrs) => {
		for(var key in att){
			el.setAttribute(key, att[key]);
		}
	}

	setAttrElement(createInputGift, {
		"type": "hidden",
		"name": "id[]",
		"value": productGiftDataObj.id
	});

	console.log(createInputGift);
  }

  const addToCartButton = document.createElement('button');
  addToCartButton.classList.add('upsell__button', 'button', 'button--primary');
  addToCartButton.innerHTML = `Añadir a la cesta`;

  addToCartButton.onclick = () => {
    addToCart(firstVariant);
  };
  bottomWrapper.appendChild(addToCartButton);
  infoWrapper.appendChild(bottomWrapper);
  return infoWrapper;
};


const addToCart = (firstVariant) => {
  const quantity = 1;
  const item = { id: firstVariant.id, quantity: quantity };
  
  const upsellWrapper = document.querySelector('cart-drawer .convertlab__upsell');
  const upsellTestWrapper = document.querySelector('cart-drawer-test .convertlab__upsell')
  const cartWrapper = document.querySelector('cart-drawer-items');
  const cartTestWrapper = document.querySelector('cart-drawer-test-items');
  const barWrapper = document.querySelector('.drawer__progress-bar');
	
  const sliderContainer = document.querySelectorAll('.upsell-slider__container');
  sliderContainer.forEach((sliderContent) => {
	sliderContent.innerHTML = `<div class="loading-overlay__spinner" id="loading-upsell">
		<svg
			aria-hidden="true"
			focusable="false"
			class="spinner"
			viewBox="0 0 66 66"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
		</svg>
	</div>`;
  })
 

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(item),
  })
    .then((response) => response.json())
    .then(async (data) => {
      const drawerItems = await renderShopifySection('cart-drawer-items');
	  const drawerTestItems = await renderShopifySection('cart-drawer-test-items');
	  const barRewards 	= await renderShopifySection('cart-bar-rewards');
      const upsellItems = await renderShopifySection('convertlab-upsell-slider');

      if (drawerItems && upsellItems) {
        if(cartWrapper) cartWrapper.innerHTML = stringToHTML(drawerItems['cart-drawer-items']).outerHTML;
		if(cartTestWrapper) cartTestWrapper.innerHTML = stringToHTML(drawerTestItems['cart-drawer-test-items']).outerHTML;
		if(upsellWrapper) upsellWrapper.innerHTML = stringToHTML(upsellItems['convertlab-upsell-slider']).outerHTML;
		if(upsellTestWrapper) upsellTestWrapper.innerHTML = stringToHTML(upsellItems['convertlab-upsell-slider']).outerHTML;
		barWrapper.innerHTML = stringToHTML(barRewards['cart-bar-rewards']).outerHTML;
		setTimeout(() => {
			initializeUpsell()
		}, 1000);
      }
    })
    .catch((error) => console.error(error))
}

const swiper = (elementOrClass = '.upsell__swiper') => {
	// Initialize the swiper slider
	let myPagination = document.querySelector(`.swiper-pagination.custom.upsell`);
	
	let mySwiperNext = document.querySelector(`.swiper-button-next[data-target="upsell"]`)
	let mySwiperPrev = document.querySelector(`.swiper-button-prev[data-target="upsell"]`)

	const navigationObj = {
		nextEl: mySwiperNext,
		prevEl: mySwiperPrev,
	};

	let paginationObj = {
		el: myPagination
	};

	//console.log(navigationObj);
	let typeProgress = 	 document.body.getAttribute('data-use-test-cart');
	if(typeProgress){
		paginationObj = {
		...paginationObj,
		type: "progressbar"
		}
	}

	const slider = new Swiper(elementOrClass, {
		slidesPerView: 1,
		centeredSlides: true,
		loop: true,
		pagination: paginationObj,
		navigation: navigationObj,
		spaceBetween: 15,
		autoplay: {
			delay: 5000,
			disableOnInteraction: true,
			pauseOnMouseEnter: true,
		},
		breakpoints: {
			1000: {
				slidesPerView: 2.5,
				centeredSlides: false,
				disableOnInteraction: true,
				pauseOnMouseEnter: true,
				direction: 'vertical',
				grabCursor: true,
				spaceBetween: 30,
			},
		},
	})
	// console.log(slider)
	return slider;
}

const support = () => {
	if (!window.DOMParser) return false;
	const parser = new DOMParser();
  try {
		parser.parseFromString('x', 'text/html');
	} catch (err) {
		return false;
	}
	return true;
};

const stringToHTML = (str) => {
	// If DOMParser is supported, use it
	if (support()) {
		const parser = new DOMParser();
		const doc = parser.parseFromString(str, 'text/html');
		return doc.body;
	}
	// Otherwise, fallback to old-school method
	const dom = document.createElement('div');
	dom.innerHTML = str;
	return dom;
}


if ( window.location.pathname === '/' ) {
    document.addEventListener('StartAsyncLoading',function(event){ initializeUpsell(); });
} else {
    initializeUpsell();  
}

    
